// cmcUsageConst.js
// Bundled consts for the Cmc Usage domain (see Development.Patterns rk=a786510f).
const cmcUsageConst = {
    // RK names as they come back from CmcUsageItemDto — avoids magic strings elsewhere.
    RK: {
        RATE_LIMIT_MINUTE: 'Rate_limit_minute',
        MINUTE_REQUEST_USED: 'Minute_RequestUsed',
        MINUTE_REQUESTS_LEFT: 'Minute_RequestsLeft',
        MONTH_CREDITS_USED: 'Month_CreditsUsed',
        MONTH_CREDITS_LEFT: 'Month_CreditsLeft',
        CREDIT_LIMIT_MONTHLY: 'Credit_limit_monthly',
        CREDIT_LIMIT_MONTHLY_RESET: 'Credit_limit_monthly_reset',
        CREDIT_LIMIT_MONTHLY_RESET_TIMESTAMP: 'Credit_limit_monthly_reset_timestamp',
        DAY_CREDITS_USED: 'Day_CreditsUsed',
        DAY_CREDITS_LEFT: 'Day_CreditsLeft',
    },
    // Usage-percentage bands — used for both month and day scope.
    BANDS: [
        { max: 70, label: 'ok', color: '#639922' },
        { max: 90, label: 'high', color: '#EF9F27' },
        { max: 100, label: 'critical', color: '#E24B4A' },
    ],
};

export default cmcUsageConst;
